<template>
    <v-container>
        <!-- Hero Section for News -->
        <v-card v-if="recentNews" class="my-4 elevation-2 rounded-lg hero-news-card" outlined>
            <div class="d-flex align-center justify-space-between px-4 py-2 grey lighten-4 border-bottom">
                <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2" small>mdi-bullhorn-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">Τελευταίες Ενημερώσεις &amp; Νέα</span>
                    <v-chip x-small color="primary" class="ml-2 font-weight-bold" outlined>
                        {{ newsEntries.length }}
                    </v-chip>
                </div>
                <div class="d-flex align-center" v-if="newsEntries.length > 1">
                    <v-btn icon x-small @click="prevSlide" :disabled="heroIndex === 0" title="Προηγούμενο">
                        <v-icon small>mdi-chevron-left</v-icon>
                    </v-btn>
                    <span class="caption grey--text text--darken-2 font-weight-bold mx-1">
                        {{ heroIndex + 1 }} / {{ newsEntries.length }}
                    </span>
                    <v-btn icon x-small @click="nextSlide" :disabled="heroIndex === newsEntries.length - 1" title="Επόμενο">
                        <v-icon small>mdi-chevron-right</v-icon>
                    </v-btn>
                </div>
            </div>

            <v-carousel
                v-model="heroIndex"
                height="165"
                hide-delimiters
                :show-arrows="false"
                light
            >
                <v-carousel-item
                    v-for="(newsEntry, index) in newsEntries"
                    :key="newsEntry.id"
                >
                    <div class="px-5 py-3 h-100 d-flex flex-column justify-start">
                        <div class="d-flex align-center mb-1">
                            <v-chip x-small color="primary" class="mr-2 font-weight-bold flex-shrink-0" label>
                                <v-icon left x-small>mdi-calendar-check-outline</v-icon>
                                {{ newsEntry.date }}
                            </v-chip>
                            <span class="text-subtitle-2 font-weight-bold primary--text text-truncate">
                                {{ getNewsTitle(newsEntry.contents) }}
                            </span>
                        </div>
                        <div class="news-hero-content text-body-2 grey--text text--darken-3 mt-1" v-html="newsEntry.contents">
                        </div>
                    </div>
                </v-carousel-item>
            </v-carousel>
        </v-card>

        <v-spacer></v-spacer>

        <v-card class="my-4">
            <v-card-title>Κατάσταση MyData</v-card-title>
            
            <v-card-text>
                   <v-data-table
                    :headers="headers"
                    :items="myDataLogs"
                    :loading="loading"
                    loading-text="Φόρτωση αρχείων καταγραφής myDATA..."
                    no-data-text="Δεν υπάρχουν δεδομένα"
                    :item-class="tableRowClassGenerator"
                    :sort-by="['success', 'issue_date', 'document_type', 'document_number']"
                    :sort-desc="[false, true, false, true]"
                    class="elevation-1">
                    </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            heroIndex: 0,
            newsEntries: [],
            myDataLogs: [],

            headers: [
                { 
                    text: 'Έκδοση',
                    align: 'center', 
                    value: 'issue_date', 
                },
                { 
                    text: 'Παραστατικό',
                    align: 'center', 
                    value: 'document_type', 
                },
                { 
                    text: 'Αριθμός',
                    align: 'center', 
                    value: 'document_number', 
                },
                { 
                    text: 'Πελάτης',
                    align: 'center', 
                    value: 'customer_name', 
                },
                { 
                    text: 'Ανέβασμα',
                    align: 'center', 
                    value: 'created_at', 
                },
                { 
                    text: 'Απάντηση ΑΑΔΕ',
                    align: 'center', 
                    value: 'message', 
                },
            ],
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            this.loading = true;

            axios.get('/api/mydata')
            .then(response => {
                this.myDataLogs = response.data
            }).catch(e => console.error(e)).finally(() => { this.loading = false; })

            axios.get('/api/news')
            .then(response => {
                this.newsEntries = response.data
            })
        },

        prevSlide() {
            if (this.heroIndex > 0) {
                this.heroIndex--;
            }
        },

        nextSlide() {
            if (this.heroIndex < this.newsEntries.length - 1) {
                this.heroIndex++;
            }
        },

        getNewsTitle(contents) {
            if (!contents) return '';
            const firstLine = contents.split(/<br\s*\/?>/i)[0];
            const stripped = firstLine.replace(/<[^>]+>/g, '').trim();
            const cleanTitle = stripped.replace(/[:\-–—\s]+$/, '');
            if (cleanTitle.length > 90) {
                return cleanTitle.substring(0, 87) + '...';
            }
            return cleanTitle;
        },

        tableRowClassGenerator(item) {
            if (item.success == 0)
                return 'red lighten-3'

            return 'green lighten-4'
        },
    },

    computed: {
        myDataErrors() {
            return this.myDataLogs.filter(x => x.success == 0).length > 0
        },

        recentNews() {
            return this.newsEntries.length > 0
        }
    }
}
</script>

<style scoped>
.hero-news-card {
    border: 1px solid #e2e8f0;
    background: #ffffff;
}
.news-hero-content {
    line-height: 1.6;
    max-height: 110px;
    overflow-y: auto;
    padding-right: 4px;
}
.news-hero-content::-webkit-scrollbar {
    width: 4px;
}
.news-hero-content::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}
</style>
